import Utils from "../../../../../Utils";

export default function getCellCustomEditor() {

    function AgSelect() {
    }

    AgSelect.prototype.init = function (params) {
        this.params = params;
        this.defaultValue = {...params.value};
        AgSelect.prototype.cellEditorparams = params.data.cellEditorParams || {};
        if (this.params.data.id === -1) {
            this.eInput = document.createElement('select');
            this.eInput.id = 'grid-drop-down';
            this.eInput.style.width = "100%";
            params.column.userProvidedColDef.options.forEach((item, index) => {
                let option = new Option(item.name, JSON.stringify({id: item.id, name: item.name}));
                if (index === 0 ){
                    this.selectValue = option;
                }
                Utils.$(this.eInput).append(option)
            })
        } else {
            this.eInput = document.createElement('div');
        }
    };

    AgSelect.prototype.isKeyPressedNavigation = function (event) {
        return event.keyCode === 39 || event.keyCode === 37;
    };

    AgSelect.prototype.getGui = function () {
        return this.eInput;
    };

    AgSelect.prototype.afterGuiAttached = function () {
        if (this.params.data.id === -1) {
            Utils.$(this.eInput).select2().val(this.params.value).trigger("change");
            Utils.$(this.eInput).select2({width: this.params.eGridCell.offsetWidth});
            this.eInput.focus();
            Utils.$(this.eInput).select2('open');
        } else {
            Utils.$(this.eInput).text = this.params.value.name;
        }
    };

    AgSelect.prototype.isCancelBeforeStart = function () {
        return false
    };

    AgSelect.prototype.isCancelAfterEnd = function () {
        return false
    };

    AgSelect.prototype.getValue = function () {
        if (Utils.$(this.eInput).val()) {
            return JSON.parse(Utils.$(this.eInput).val());
        }
        if (this.defaultValue.id === -1) {
           return JSON.parse(this.selectValue.value);
        }
        return this.defaultValue;
    };

    AgSelect.prototype.destroy = function () {
        this.eInput.remove();
        Utils.$(this.eInput).select2('close');
    };

    AgSelect.prototype.isPopup = function () {
        try {
            return AgSelect.prototype.cellEditorparams.isPopup
        } catch (e) {
            return false;
        }
    };

    return AgSelect
}




// WEBPACK FOOTER //
// ./app/components/bo-core/grids/DataViewConfigAgGrid/components/AgGridSelect.tsx